import { render, staticRenderFns } from "./ReviewCard.vue?vue&type=template&id=34ae7626&scoped=true"
import script from "./ReviewCard.vue?vue&type=script&lang=js"
export * from "./ReviewCard.vue?vue&type=script&lang=js"
import style0 from "./ReviewCard.vue?vue&type=style&index=0&id=34ae7626&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34ae7626",
  null
  
)

export default component.exports